import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const AdmissionYearList = Loadable(
  lazy(() => import("features/admissionYear/components/List"))
);
const AdmissionYearPage = Loadable(
  lazy(() => import("features/admissionYear/components/Page"))
);

const routes = {
  path: "admissionYear",
  children: [
    { path: "", element: <AdmissionYearList /> },
    { path: "add", element: <AdmissionYearPage /> },
    { path: "edit/:admissionYearID?", element: <AdmissionYearPage /> },
  ],
};

export default routes;
